import $ from "jquery";
import Gtm from "./GTM";

declare let $$epiforms: any; // eslint-disable-line @typescript-eslint/no-explicit-any

class EpiForms {
    constructor() {
        this.InitEpiForms();
    }

    InitEpiForms() {
        const gtm = new Gtm();

        $("form.EPiServerForms").on("input", function () {
            if (!$(this).data("changed")) gtm.datalayerPush("form_start");
            $(this).data("changed", true);
        });

        $("form.EPiServerForms").on("submit", function () {
            gtm.datalayerPush("form_submission");
        });

        if (typeof $$epiforms !== "undefined") {
            $$epiforms(document).ready(function myfunction() {
                $$epiforms(".EPiServerForms").on("formsSubmitted", function () {
                    gtm.datalayerPush("form_submission");
                });
            });
        }
    }
}

export default EpiForms;
